import React from "react";
import { MapPin, Compass, Sparkles } from "lucide-react";
import MarketingPage, { MarketingSection, Pillar } from "@/apps/rider/components/MarketingPage";

const ACTIVE_AREAS = [
  { name: "Kansas City, MO",        note: "Downtown, River Market, Crossroads, Crown Center" },
  { name: "Overland Park, KS",      note: "Corporate Woods, Sprint Campus, College Blvd corridor" },
  { name: "Lee's Summit, MO",       note: "Downtown LS, Lakewood, Summit Fair" },
  { name: "Independence, MO",       note: "Independence Square, Centerpoint, 23rd St corridor" },
  { name: "Olathe, KS",             note: "Olathe Health, College of Health Sciences, K-7 corridor" },
  { name: "Lenexa, KS",             note: "City Center, Lenexa Logistics Park" },
  { name: "Shawnee, KS",            note: "Shawnee Mission Pkwy, Nieman Rd" },
  { name: "North Kansas City, MO",  note: "Armour Rd, NKC Hospital, Briarcliff" },
  { name: "Liberty, MO",            note: "Liberty Hospital, Liberty Marketplace, MO-152 corridor" },
  { name: "Blue Springs, MO",       note: "Adams Pointe, Mall at Fall Creek, MO-7 corridor" },
  { name: "Raymore, MO",            note: "Foxwood, Centerview, US-71 corridor" },
  { name: "Belton, MO",             note: "Belton Town Center, Y Hwy, Belton-Raymore corridor" },
  { name: "Gladstone, MO",          note: "Gladstone Plaza, Antioch corridor, NE 72nd" },
];

export default function ServiceAreas() {
  return (
    <MarketingPage
      eyebrow="Where Link runs"
      title="Built for the Kansas City commute."
      lede="Link operates across the greater Kansas City metro, with routes up to 50 miles one-way. Every neighborhood listed below has an active driver pool sized to keep pickup windows tight."
      back="/"
      backLabel="Home"
      testId="service-areas-page"
      cta={{ to: "/", label: "Schedule a ride" }}
    >
      {/* Active map */}
      <MarketingSection eyebrow="Active service" title="Where we run today." testId="sa-active">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 not-prose mt-2">
          {ACTIVE_AREAS.map((a, i) => (
            <div
              key={a.name}
              className="bg-white border hairline rounded-2xl p-4 hover:border-[#ed6500]/40 transition-colors"
              data-testid={`sa-active-${i}`}
            >
              <div className="flex items-center gap-2.5">
                <span className="w-7 h-7 inline-flex items-center justify-center rounded-lg bg-[#FCEADE] text-[#ed6500] shrink-0">
                  <MapPin size={13} strokeWidth={2} />
                </span>
                <div className="font-semibold text-[#0A1128] text-[14.5px] leading-tight">{a.name}</div>
              </div>
              <div className="text-[12px] text-[#515E7B] mt-1.5 ml-9 leading-snug">{a.note}</div>
            </div>
          ))}
        </div>
        <p className="mt-5 text-[14px]">
          Don't see your neighborhood? <a href="/support/contact" className="text-[#ed6500] underline-offset-4 hover:underline">Tell us where you commute</a> — rider requests guide where Link grows next.
        </p>
      </MarketingSection>

      <MarketingSection eyebrow="Routes" title="Up to 50 miles, one-way." testId="sa-routes">
        <p>
          Link routes are point-to-point: one origin, one destination, and the round-trip back at the end of your day. Distance is measured along the actual driving route — no straight-line shortcuts. Routes longer than 50 miles one-way require a custom arrangement; <a href="/support/contact" className="text-[#ed6500] underline-offset-4 hover:underline">contact support</a> for a quote.
        </p>
      </MarketingSection>

      {/* Decorative grid */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Pillar Icon={Compass} title="Tight windows" testId="sa-pillar-windows">
          We size driver pools to keep pickup windows under 10 minutes of variance.
        </Pillar>
        <Pillar Icon={MapPin} title="Real coverage" testId="sa-pillar-coverage">
          A neighborhood goes live only after we've confirmed it has commute density.
        </Pillar>
        <Pillar Icon={Sparkles} title="Local first" testId="sa-pillar-local">
          We grow city-by-city, not nationwide-from-day-one.
        </Pillar>
      </div>
    </MarketingPage>
  );
}
